module.exports = __webpack_public_path__ + "img/mobile_login_ikmv.b14a5396.svg";